import { createAction, props } from '@ngrx/store';
import { salesChannel } from 'src/app/pages/orders/interfaces/salesChannel.interface';

export const loadSalesChannels = createAction('[Sales Channels] Load');

export const loadSalesChannelsSuccess = createAction(
  '[Sales Channels] Load Success',
  props<{ response: salesChannel[] }>(),
);

export const loadSalesChannelsSuccessByKey = createAction(
  '[Sales Channels] Load Success By Key',
  props<{ key: string; response: salesChannel[] }>(),
);

export const loadSalesChannelsFailure = createAction('[Sales Channels] Load Failure', props<{ error: any }>());
